import { orejime } from "../../scripts/orejime";

const footerJsClass = 'js-footer';
const footerButtonJsClass = footerJsClass + '-button';

const footerButtonElement = document.querySelector('.' + footerButtonJsClass) as HTMLElement;

if (footerButtonElement) {
    footerButtonElement.addEventListener('click', () => {
        orejime.show();
    });
}